import { CheckUtils } from "./check-utils";
var UserUtils = /** @class */ (function () {
    function UserUtils() {
    }
    UserUtils.getDisplayName = function (author) {
        var result = "";
        if (author != null) {
            if (!CheckUtils.isEmpty(author.displayName)) {
                result = author.displayName;
            }
            else if (!CheckUtils.isEmpty(author.firstname)) {
                result = author.firstname;
                if (!CheckUtils.isEmpty(author.lastName)) {
                    result += " " + author.lastName.charAt(0);
                }
            }
            else if (!CheckUtils.isEmpty(author.lastName)) {
                result += " " + author.lastName;
            }
            else if (CheckUtils.isEmpty(result)) {
                author.firstname = "Anonymous";
                result = author.firstname;
            }
        }
        return result;
    };
    return UserUtils;
}());
export { UserUtils };
//# sourceMappingURL=user-utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-utils/user-utils.js
// module id = 981
// module chunks = 14